var render = function () {
  var _class, _class2, _class3, _class4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.highlight] = _vm.highlight, _class[_vm.$style.smallTheme] = _vm.smallTheme, _class)
  }, [_c('div', {
    class: (_class2 = {}, _class2[_vm.$style.positionIcon] = true, _class2[_vm.$style.highlight] = _vm.highlight, _class2)
  }, [_c('h1', {
    staticClass: "color-white"
  }, [_vm._v(_vm._s(_vm.leaderboardPosition))])]), _c('div', {
    class: (_class3 = {}, _class3[_vm.$style.winnerInfo] = true, _class3[_vm.$style.highlight] = _vm.highlight, _class3)
  }, [_c('h3', {
    attrs: {
      "data-leaderboard-position-name": ""
    }
  }, [_vm._v(_vm._s(_vm.getName))]), !_vm.smallTheme ? _vm._l(_vm.getAddresses, function (address, index) {
    return _c('h4', {
      key: index
    }, [_vm._v(_vm._s(address))]);
  }) : _vm._e()], 2), _c('div', {
    class: (_class4 = {}, _class4[_vm.$style.rankValue] = true, _class4[_vm.$style.highlight] = _vm.highlight, _class4)
  }, [_vm.highlight ? _c('h3', [_vm._v(_vm._s(_vm.getRankValue))]) : _vm._e(), !_vm.highlight ? _c('p', {
    staticClass: "button-text color-dark-gray"
  }, [_vm._v(_vm._s(_vm.getRankValue))]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }